module.exports = __webpack_public_path__ + "img/trip_sendai24.02fd1f97.jpg";